if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');

        this.applyIOSConstrainHeightFix();

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      applyIOSConstrainHeightFix() {
        const isIOS =
          /iP(hone|ad|od)/.test(navigator.platform) ||
          (navigator.userAgent.includes('Mac') && 'ontouchend' in document);

        if (!isIOS) return;

        const scope = this || document;

        scope.querySelectorAll('.product-media-container.constrain-height').forEach((el) => {
          el.classList.remove('constrain-height');
          el.style.maxHeight = 'none';
          el.style.height = 'auto';
        });
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        const isThreeColumnLayout = this.closest('.product--info-layout-three-column');
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        this.applyIOSConstrainHeightFix();

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (
            !this.elements.thumbnails ||
            this.dataset.desktopLayout === 'stacked' ||
            this.dataset.desktopLayout === 'three_column' ||
            isThreeColumnLayout
          ) {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
// Keep gallery photos matched to the selected colour.
subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
  const { sectionId, html } = event.data;
  if (!html) return;

  document.querySelectorAll('media-gallery').forEach((gallery) => {
    const updatedGallery = html.getElementById(gallery.id);
    if (!updatedGallery || !gallery.id.startsWith(`MediaGallery-${sectionId}`)) return;

    gallery.querySelectorAll('[data-media-id], [data-target]').forEach((item) => {
      const attribute = item.hasAttribute('data-media-id')
        ? 'data-media-id'
        : 'data-target';

      const updatedItem = Array.from(
        updatedGallery.querySelectorAll(`[${attribute}]`)
      ).find((candidate) =>
        candidate.getAttribute(attribute) === item.getAttribute(attribute)
      );

      if (!updatedItem) return;

      if (updatedItem.style.display === 'none') {
        item.style.setProperty('display', 'none', 'important');
      } else {
        item.style.removeProperty('display');
      }
    });

    gallery.querySelectorAll('slider-component').forEach((slider) => {
      if (typeof slider.resetPages === 'function') slider.resetPages();
    });
  });
});
// Connect the gallery to the colour swatch app.
(() => {
  const normalize = (value) =>
    String(value || '').trim().toLowerCase();

  let pending = false;
  const watched = new WeakSet();

  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      sync();
    });
  }

  function sync() {
    document.querySelectorAll('[id="bcpo"]').forEach((picker) => {
      const colourGroup = Array.from(
        picker.querySelectorAll('.selector-wrapper')
      ).find((group) => {
        const title = normalize(
          group.querySelector('.bcpo-title')?.textContent
        ).replace(/:$/, '');
        return ['color', 'colour', 'اللون'].includes(title);
      });

      if (!colourGroup) return;

      const controls = Array.from(
        colourGroup.querySelectorAll('input[type="radio"]')
      );
      const selected = controls.find((input) => input.checked);
      if (!selected) return;

      const colour = normalize(selected.value);
      const colours = new Set(
        controls.map((input) => normalize(input.value))
      );
      const section = picker.closest(
        '[id^="MainProduct-"], .shopify-section'
      );
      if (!section) return;

      function filter(item) {
        const alt = normalize(item.getAttribute('data-media-alt'));
        if (!colours.has(alt)) return;

        [
          'product__media-item--variant',
          'thumbnail-list_item--variant'
        ].forEach((name) => {
          if (item.classList.contains(name)) {
            item.classList.remove(name);
          }
        });

        if (alt !== colour) {
          if (
            item.style.getPropertyValue('display') !== 'none' ||
            item.style.getPropertyPriority('display') !== 'important'
          ) {
            item.style.setProperty('display', 'none', 'important');
          }

          item.querySelectorAll('video').forEach((video) => {
            if (!video.paused) video.pause();
          });
        } else if (item.style.getPropertyValue('display') === 'none') {
          item.style.removeProperty('display');
        }
      }

      section.querySelectorAll('media-gallery').forEach((gallery) => {
        gallery.querySelectorAll('[data-media-alt]').forEach(filter);

        if (typeof gallery.updateVideoButton === 'function') {
          gallery.updateVideoButton();
        }

        const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
        const slides = viewer
          ? Array.from(
              viewer.querySelectorAll(
                '.product__media-item[data-media-id]'
              )
            )
          : [];

        const active = slides.find((slide) =>
          slide.classList.contains('is-active')
        );

        if (active && active.style.display === 'none') {
          const next =
            slides.find(
              (slide) => normalize(slide.dataset.mediaAlt) === colour
            ) ||
            slides.find((slide) => slide.style.display !== 'none');

          if (next && typeof gallery.setActiveMedia === 'function') {
            gallery.setActiveMedia(next.dataset.mediaId, false);
          }
        }

        if (gallery.dataset.sculptdSelectedColour !== colour) {
          gallery.dataset.sculptdSelectedColour = colour;
          gallery.querySelectorAll('slider-component').forEach((slider) => {
            if (
              slider.slider &&
              slider.nextButton &&
              typeof slider.resetPages === 'function'
            ) {
              slider.resetPages();
            }
          });
        }

        if (!watched.has(gallery)) {
          watched.add(gallery);
          new MutationObserver(schedule).observe(gallery, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: ['style', 'class']
          });
        }
      });

      section
        .querySelectorAll('product-modal [data-media-alt]')
        .forEach(filter);
    });
  }

  ['change', 'click'].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      if (event.target.closest?.('[id="bcpo"]')) schedule();
    }, true);
  });

  new MutationObserver((records) => {
    const addedPicker = records.some((record) =>
      Array.from(record.addedNodes).some((node) =>
        node.nodeType === 1 &&
        (
          node.matches('[id="bcpo"], media-gallery') ||
          node.querySelector('[id="bcpo"], media-gallery')
        )
      )
    );
    if (addedPicker) schedule();
  }).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
})();
// Add a Watch video button for the selected colour.
customElements.whenDefined('media-gallery').then(() => {
  const Gallery = customElements.get('media-gallery');

  Gallery.prototype.updateVideoButton = function () {
    const findVideo = () =>
      Array.from(
        this.querySelectorAll('.product__media-item[data-media-id]')
      ).find((item) =>
        item.style.display !== 'none' &&
        item.querySelector(
          '.media-type-video, .media-type-external_video'
        )
      );

    let button = this.querySelector('[data-colour-video-button]');

    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'button button--secondary';
      button.textContent = '▶ Watch video';
      button.setAttribute('data-colour-video-button', '');
      button.style.gridColumn = '1 / -1';
      button.style.marginBottom = '16px';

      button.addEventListener('click', () => {
        const video = findVideo();
        if (!video) return;

        this.setActiveMedia(video.dataset.mediaId, false);
        video.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      });

      this.prepend(button);
    }

    const display = findVideo() ? 'inline-flex' : 'none';
    if (button.style.display !== display) {
      button.style.setProperty('display', display, 'important');
    }
  };

  document.querySelectorAll('media-gallery').forEach((gallery) => {
    gallery.updateVideoButton();
  });
});
  // Open colour videos in a small popup.
(() => {
  const style = document.createElement('style');
  style.textContent = `
    media-gallery .product__media-item:has(.media-type-video),
    media-gallery .product__media-item:has(.media-type-external_video) {
      display: none !important;
    }
    dialog.sculptd-video-popup {
      position: fixed;
      inset: 0;
      margin: auto;
      width: min(90vw, 420px);
      max-height: 85vh;
      padding: 44px 12px 12px;
      border: 0;
      border-radius: 14px;
      background: white;
      box-sizing: border-box;
      overflow: auto;
    }
    dialog.sculptd-video-popup::backdrop {
      background: rgba(0, 0, 0, .65);
    }
    .sculptd-video-popup video {
      display: block;
      width: 100%;
      max-height: 68vh;
      object-fit: contain;
    }
    .sculptd-video-popup iframe {
      display: block;
      width: 100%;
      height: 65vh;
      border: 0;
    }
    .sculptd-video-close {
      position: absolute;
      top: 6px;
      right: 8px;
      width: 34px;
      height: 34px;
      padding: 0;
      border: 0;
      background: white;
      color: black;
      font-size: 28px;
      cursor: pointer;
    }
  `;
  document.head.append(style);

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.(
      '[data-colour-video-button]'
    );
    if (!button) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const gallery = button.closest('media-gallery');
    if (!gallery) return;

    const item = Array.from(
      gallery.querySelectorAll('.product__media-item')
    ).find((item) =>
      item.style.display !== 'none' &&
      item.querySelector(
        '.media-type-video, .media-type-external_video'
      )
    );
    if (!item) return;

    const template = item.querySelector('template');
    const source =
      item.querySelector('video, iframe') ||
      template?.content.querySelector('video, iframe');
    if (!source) return;

    document.querySelector('.sculptd-video-popup')?.close();

    const popup = document.createElement('dialog');
    popup.className = 'sculptd-video-popup';
    popup.setAttribute('aria-label', 'Product video');

    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'sculptd-video-close';
    close.textContent = '×';
    close.setAttribute('aria-label', 'Close video');

    const player = source.cloneNode(true);
    if (player.tagName === 'VIDEO') {
      player.controls = true;
      player.autoplay = true;
      player.playsInline = true;
      player.removeAttribute('id');
    }

    close.addEventListener('click', () => popup.close());
    popup.addEventListener('cancel', (event) => {
      event.preventDefault();
      popup.close();
    });
    popup.addEventListener('close', () => {
      if (player.pause) player.pause();
      popup.remove();
      button.focus({ preventScroll: true });
    }, { once: true });

    popup.append(close, player);
    document.body.append(popup);
    popup.showModal();

    if (player.play) {
      player.play().catch(() => {});
    }
  }, true);
})();